import { lazySaveOfflineSessionData } from 'owa-offline-session-data';
import type { SessionData } from 'owa-service/lib/types/SessionData';

export const saveOfflineSessionData = (
    networkSD: SessionData,
    offlineSD: SessionData
): Promise<void> => lazySaveOfflineSessionData.importAndExecute(networkSD, offlineSD);
